import { Component, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Subscription } from 'rxjs';

import { SideMenusService } from '../../side-menus/side-menus.service';

@Component({
  selector: 'app-teams-top-navbar',
  templateUrl: './teams-top-navbar.component.html',
  styleUrls: ['./teams-top-navbar.component.scss']
})
export class TeamsTopNavbarComponent implements AfterViewInit, OnDestroy {
  @ViewChild('mainSidenav') mainSidenav!: MatSidenav;
  @ViewChild('altSidenav') altSidenav!: MatSidenav;

  // Template expects these:
  mainSideMenuMode: string = 'side'; // Always use 'side' mode for beta menu
  mainSidenavOpened = true; // Always open for beta menu hover functionality
  menuOpen = false;

  private mainToggleSub?: Subscription;
  private altToggleSub?: Subscription;
  private modeSub?: Subscription;
  private openStateSub?: Subscription;

  constructor(private sideMenusService: SideMenusService) {}

  ngAfterViewInit(): void {
    // Ensure sidenav is always open for beta menu
    if (!this.mainSidenav.opened) {
      this.mainSidenav.open();
    }
    
    // Respond to global menu toggle requests
    this.mainToggleSub = this.sideMenusService.toggleMainMenuSubject.subscribe((event) => {
      // For beta menu, always keep the menu open - ignore toggle/close commands
      if (event === 'open') {
        this.mainSidenav.open();
      }
      // Ignore 'toggle' and 'close' to keep menu always visible
    });

    this.altToggleSub = this.sideMenusService.toggleAltMenuSubject.subscribe((event) => {
      if (event === 'open') this.altSidenav.open();
      else if (event === 'close') this.altSidenav.close();
      else this.altSidenav.toggle();
    });

    this.modeSub = this.sideMenusService.changeMainMenuModeSubject.subscribe((mode) => {
      this.mainSideMenuMode = mode;
    });

    // Keep icons in sync with real open state
    this.openStateSub = this.sideMenusService.mainMenuOpen$.subscribe((isOpen) => {
      this.menuOpen = isOpen;
      this.mainSidenavOpened = isOpen;
    });
  }

  ngOnDestroy(): void {
    this.mainToggleSub?.unsubscribe();
    this.altToggleSub?.unsubscribe();
    this.modeSub?.unsubscribe();
    this.openStateSub?.unsubscribe();
  }

  toggleMainMenu(): void {
    this.sideMenusService.toggleMainMenuSubject.next('toggle');
  }

  openedStart(): void {
    // no-op; but template expects method
  }

  mainSidenavToggled(opened: boolean): void {
    // Force sidenav to stay open for beta menu hover functionality
    if (!opened && this.mainSidenav) {
      setTimeout(() => {
        if (this.mainSidenav && !this.mainSidenav.opened) {
          this.mainSidenav.open();
        }
      }, 0);
    }
    this.mainSidenavOpened = true; // Always set to true
    this.sideMenusService.setMainMenuState(true);
  }

  altSidenavToggled(opened: boolean): void {
    // If you need state later
  }
}
